import { Descriptions, Form, Input, InputNumber, Space } from 'antd'

const { TextArea } = Input

export default function Additional({ itemDisabled }) {
  return (
    <Descriptions size="small" bordered>
      <Descriptions.Item label="Hours" span={3}>
        <Space>
          {itemDisabled ? (
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const hours = getFieldValue('hours')

                return (
                  <div
                    style={{
                      width: 120,
                      minHeight: 32,
                      padding: '4px 11px',
                      border: '1px solid #d9d9d9',
                      borderRadius: 2,
                      backgroundColor: '#fafafa',
                      color: 'rgba(0, 0, 0, 0.88)',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {hours ?? ''}
                  </div>
                )
              }}
            </Form.Item>
          ) : (
            <Form.Item hasFeedback name="hours">
              <InputNumber placeholder="Hours" min={0} disabled={itemDisabled} />
            </Form.Item>
          )}
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Notes" span={3}>
        <Space>
          {itemDisabled ? (
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const notes = getFieldValue('notes')

                return (
                  <div
                    style={{
                      width: 500,
                      minHeight: 98,
                      padding: '8px 11px',
                      border: '1px solid #d9d9d9',
                      borderRadius: 2,
                      backgroundColor: '#fafafa',
                      color: 'rgba(0, 0, 0, 0.88)',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                    }}
                  >
                    {notes || ''}
                  </div>
                )
              }}
            </Form.Item>
          ) : (
            <Form.Item hasFeedback name="notes">
              <TextArea
                showCount
                maxLength={255}
                allowClear
                style={{ width: 500 }}
                placeholder="Add additional information about this item"
                rows={4}
                disabled={itemDisabled}
              />
            </Form.Item>
          )}
        </Space>
      </Descriptions.Item>
    </Descriptions>
  )
}
